/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import { action } from '@ember/object';

export default class Faqs extends Component {
  @service analytics!: AnalyticsService;

  get faqs() {
    return Object.freeze([
      {
        question: 'Do you have an EU Data Processing Addendum?',
        answer:
          '<p>Yes, we provide the latest version of the Customer.io DPA for you to read or download on <a href="https://customer.io/legal/dpa/" target="_blank" rel="noopener noreferrer">our legal page</a>. You can find additional information regarding <a href="https://customer.io/legal/gdpr/" target="_blank" rel="noopener noreferrer">GDPR &amp; Customer.io here</a>, as well as more information about <a href="https://customer.io/legal/security/" target="_blank" rel="noopener noreferrer">our security practices here</a>.</p>',
      },
      {
        question: 'How do I report a security vulnerability?',
        answer: `<p>Our Site Reliability team rapidly investigates all reported security issues. If you believe you've discovered a bug in Customer.io's security, please get in touch by email at <a href="mailto:ctf@customer.io">ctf@customer.io</a>. We will respond as quickly as possible to your report. We request that you not publicly disclose the issue until it has been addressed by Customer.io's Site Reliability team.</p>
          <p>Learn more by reading our <a href="https://customer.io/legal/reporting-vulnerability/" target="_blank" rel="noopener noreferrer">report a vulnerability</a> page. </p>`,
      },
      {
        question: 'What is your PCI compliance status?',
        answer:
          "<p>When you purchase a paid Customer.io subscription, your credit card data is not transmitted through nor stored on our systems. Instead, we depend on Stripe, a company dedicated to this task. Stripe is certified to PCI Service Provider Level 1, the most stringent level of certification available. Stripe's security information is available online.</p>",
      },
      {
        question: 'What is your ISO 27001 compliance status?',
        answer:
          '<p>Customer.io does not currently maintain active ISO 27001 compliance. Our compliance program and control environment is influenced by ISO 27001 principles and we have an ISMS policy and committee within the company. We will explore formal ISO 27001 compliance at a future date.</p>',
      },
      {
        question: 'When can Customer.io employees access my data?',
        answer:
          '<p>Customer.io employees can access your account data only when:</p><ul><li>You grant approval to customer support to assist with your account</li><li>We need to stop abuse</li><li>We need to maintain our infrastructure</li></p>',
      },
      {
        question: 'How do you communicate service outages?',
        answer:
          '<p>We communicate service impacting outages to our customers via our status page at <a href="http://status.customerio.com/" target="_blank" rel="noopener noreferrer">https://status.customerio.com</a>.</p>',
      },
      {
        question: 'What is your policy for encrypted data?',
        answer:
          '<p>Data transmitted to Customer.io, via our API, is encrypted in transit through the use of the HTTPS protocol. <br /><br />Our system data is encrypted at rest using Cloud KMS services.</p>',
      },
    ]);
  }

  @action
  linkTracking() {
    return this.analytics.track('account', 'privacy_questions_viewed', {});
  }
}
